<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <div class="content">
    <h2 class="line line__1">Operator's Station</h2>

    <div class="grid-12 mt-[2rem]">
      <div class="span-12">
        <p-panel>
          <ng-template pTemplate="icons">
            <div class="table__actions">
              <div class="input-wrapper">
                <p-iconfield>
                  <p-inputicon styleClass="pi pi-search" />
                  <input pInputText #searchMachineInput type="text" />
                </p-iconfield>
              </div>
              <p-button label="Shift Change" variant="outlined" (click)="shiftChange()" />
            </div>
          </ng-template>

          <div class="grid-12">
            <div class="span-8">
              <!-- Machine tiles are already cards: grid goes straight in the panel -->
              <div class="grid-12">
                @for (machine of knittingMachines; track $index) {
                  <div class="span-6">
                    <p-card class="machine__card">
                      <div class="machine__title mb-[1rem]">
                        {{ machine.assetId }}
                        <div class="id__wrapper">
                          <span>ID</span>
                          Greige-1
                        </div>
                      </div>
                      <div class="machine__detail text__detail">
                        <b>Current Yarn Load</b>
                        <div class="form-box-row"><b>Provider:</b> Provider 1</div>
                        <div class="form-box-row"><b>Lot Provider:</b> X-001</div>
                        <div class="form-box-row"><b>Lot Item:</b> LI-5</div>
                        <!-- Weight Detail -->
                        <div class="quantity-card secondary__style">
                          <div class="grid-12">
                            <div class="span-6">
                              <h2>200 lbs</h2>
                              <h4>Initial Weight</h4>
                            </div>
                            <div class="divider"></div>
                            <div class="span-6">
                              <h2>50 lbs</h2>
                              <h4>Current Weight</h4>
                            </div>
                          </div>
                        </div>
                        <!-- Drop Box -->
                        @if (machine.currentOperatorUserName != null) {
                          <div class="operators__list mt__1">
                            <div class="operator__card">
                              <p-avatar [label]="machine.currentOperatorUserName[0]" />
                              {{ machine.currentOperatorUserName }}
                              <p-button severity="secondary" icon="pi pi-trash" (click)="removeMachineOperator($index, null)" />
                            </div>
                          </div>
                        } @else {
                          <div class="drop__wrapper mt__1" pDroppable (onDrop)="drop($index)"></div>
                        }
                      </div>
                    </p-card>
                  </div>
                }
              </div>
            </div>
            <div class="span-4">
              <p-panel header="Operators (Drag and Drog)" data-tone="surface">
                <!-- Operator tiles: already tiles, no card wrap -->
                <div class="operators__list">
                  @for (operator of operatorsList; track $index) {
                    <div class="operator__card" pDraggable (onDragStart)="dragStart(operator)" (onDragEnd)="dragEnd()">
                      <p-avatar [label]="operator.profile.firstName[0]" />
                      {{ operator.profile.firstName + ' ' + operator.profile.lastName }}
                    </div>
                  }
                </div>
              </p-panel>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</main>
